import script from "/home/d/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=script"
export * from "/home/d/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=script"

import "/home/d/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=style&index=0"
export default script
script.__scopeId = "data-v-5669b9c8"